import Card from './ui/Card.jsx';

// 5 stat cards:
// - Total cupos (todos los invitados) — cupos emitidos
// - Rechazados
// - Pendientes
// - % de respuesta
// - Total invitados confirmados (solo confirmados) — headroom
// 2-cols on mobile, 4-cols on desktop. Loading state shows skeletons.
export default function StatsCards({ stats, isLoading }) {
  const cards = [
    { key: 'total', label: 'Total invitados', value: stats?.total ?? 0 },
    {
      key: 'rechazados',
      label: 'Rechazados',
      value: stats?.cuposRechazados ?? stats?.rechazados ?? 0,
      tone: 'error',
    },
    { key: 'pendientes', label: 'Pendientes', value: stats?.pendientes ?? 0, tone: 'muted' },
    {
      key: 'porcentaje',
      label: '% de respuesta',
      value: `${stats?.porcentajeRespuesta ?? 0}%`,
      tone: 'accent',
    },
    { key: 'cupos', label: 'Total invitados confirmados', value: stats?.cuposTotales ?? 0 },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {cards.map((c) => (
        <Card key={c.key} className="flex flex-col gap-1">
          <span className="text-xs font-body text-text-muted">{c.label}</span>
          {isLoading ? (
            <span className="block h-7 w-16 animate-pulse rounded bg-border" aria-hidden="true" />
          ) : (
            <span
              className={`font-heading text-2xl ${
                c.tone === 'success'
                  ? 'text-success'
                  : c.tone === 'error'
                    ? 'text-error'
                    : c.tone === 'accent'
                      ? 'text-accent'
                      : 'text-text'
              }`}
            >
              {c.value}
            </span>
          )}
        </Card>
      ))}
    </div>
  );
}
